import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const DiscLensTeamsProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Team DISC Assessment Nigeria | DISC Lens Teams™ Lagos"
        description="DISC Lens Teams™ assessment for Nigerian teams. See how a team's styles combine, where they complement and where they clash. Built for African workplaces."
        keywords="team DISC Nigeria, team assessment Lagos, DISC team profile Nigeria, team styles Africa, DISC Lens Teams"
        canonical="https://impactasportal.com/product/disc-africa-teams"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/disc-africa-teams?embed=true"
            title="DISC Lens Teams™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default DiscLensTeamsProductPage;
